// extracted by mini-css-extract-plugin
export default {"createBranchLink":"NoBranchesOrLinkedPullRequests-module__createBranchLink__DJq8k6t"};